import React, { useState, useEffect } from 'react';
import Entities, { XmlEntities } from 'html-entities';
import { Input, Divider, Popover } from 'antd';
import BlockDisplay from './BlockDisplay';

const entities = new XmlEntities();

function FeaturedCollections({setCodeBlock}) {
  const [heading, setHeading] = useState("Featured Collections");
  const [topLeftImg, setTopLeftImg] = useState("https://cdn11.bigcommerce.com/s-aas6vytuee/product_images/uploaded_images/collection01.png");
  const [topLeftLink, setTopLeftLink] = useState("https://artisan-default-demo.mybigcommerce.com/collections/by-collection/molten-organic/");
  const [bottomLeftImg, setBottomLeftImg] = useState("https://cdn11.bigcommerce.com/s-aas6vytuee/product_images/uploaded_images/collection02.png");
  const [bottomLeftLink, setBottomLeftLink] = useState("https://artisan-default-demo.mybigcommerce.com/collections/by-collection/birthstone/");
  const [rightImg, setRightImg] = useState("https://cdn11.bigcommerce.com/s-aas6vytuee/product_images/uploaded_images/collection03.png");
  const [rightLink, setRightLink] = useState("https://artisan-default-demo.mybigcommerce.com/collections/by-collection/lucky-charms/");
  const tooltip = (
    <div>
      <span>To accomplish the same effect as the demo store, please use these dimensions.</span>
    </div>
  );

  const codeBlock = `<div class="container">
  <h2 class="page-heading">${entities.encode(heading)}</h2>
  <div class="featured-collections">
      <div class="featured-collections--double">
          <a href="${entities.encode(topLeftLink)}"><img src="${entities.encode(topLeftImg)}"/></a>
          <a href="${entities.encode(bottomLeftLink)}"><img src="${entities.encode(bottomLeftImg)}"/></a>
      </div>
      <div class="featured-collections--single">
          <a href="${entities.encode(rightLink)}"><img src="${entities.encode(rightImg)}"/></a>
      </div>
  </div>
</div>`;

  useEffect(() => {
    setCodeBlock(codeBlock);
  }, [codeBlock]);

  return (
    <div className="singleBlock">
      <div className="sidebar">
        <h2>Featured Collections Block</h2>
        <label>
          <span>Heading</span>
          <Input type="text" value={heading} onChange={(evt) => setHeading(evt.target.value)} />
        </label>
        <Divider />
        <h3>Top Left Block</h3>
        <label>
          <span>Image&nbsp;
            <Popover content={tooltip} arrowPointAtCenter placement="top">
              <a href="javascript:void(0)">(Width: 590px - Height: 330px)</a>
            </Popover>
          </span>
          <Input type="text" value={topLeftImg} onChange={(evt) => setTopLeftImg(evt.target.value)} />
        </label>
        <label>
          <span>Link url:</span>
          <Input type="text" value={topLeftLink} onChange={(evt) => setTopLeftLink(evt.target.value)} />
        </label>
        <Divider />
        <h3>Bottom Left Block</h3>
        <label>
          <span>Image&nbsp;
            <Popover content={tooltip}>
              <a href="javascript:void(0)">(Width: 590px - Height: 330px)</a>
            </Popover>
          </span>
          <Input type="text" value={bottomLeftImg} onChange={(evt) => setBottomLeftImg(evt.target.value)} />
        </label>
        <label>
          <span>Link url:</span>
          <Input type="text" value={bottomLeftLink} onChange={(evt) => setBottomLeftLink(evt.target.value)} />
        </label>
        <Divider />
        <h3>Right Block</h3>
        <label>
        <span>Image&nbsp;
            <Popover content={tooltip}>
              <a href="javascript:void(0)">(Width: 590px - Height: 680px)</a>
            </Popover>
          </span>
          <Input type="text" value={rightImg} onChange={(evt) => setRightImg(evt.target.value)} />
        </label>
        <label>
          <span>Link url:</span>
          <Input type="text" value={rightLink} onChange={(evt) => setRightLink(evt.target.value)} />
        </label>
      </div>
      <BlockDisplay codeBlock={codeBlock}/>
    </div>
  )
}

export default FeaturedCollections;
